<div class="influencer-confirmation-container" *ngIf="influencer">
  <h3 class="header">{{'INFLUENCER.confirmation.header' | translate}}</h3>
  <p class="sub-header">{{'INFLUENCER.confirmation.sub_header' | translate}}</p>
  <div *ngFor="let error of fieldErrors" class="d-flex form-error">
    <p class="error" role="alert">
      {{error.message}}
    </p>
  </div>
  <form class="influencer-confirmation-form" #influencerConfirmationForm="ngForm" (ngSubmit)="onSubmit()">
    <achoo-text-field label="{{'INFLUENCER.confirmation.full_name' | translate}}"
                      [(model)]="influencer.fullName"
                      (modelChange)="clearError('influencer.fullName')"
                      name="influencer.fullName"
                      class="input-field"
                      [showError]="false">
    </achoo-text-field>
    <achoo-text-field label="{{'INFLUENCER.confirmation.email' | translate}}"
                      [(model)]="influencer.email"
                      (modelChange)="clearError('influencer.email')"
                      name="influencer.email"
                      class="input-field"
                      [showError]="false">
    </achoo-text-field>

    <div class="term-service d-none d-sm-flex flex-row">
      <div class="custom-control custom-checkbox d-flex flex-auto align-items-center">
        <input class="custom-control-input"
               type="checkbox"
               (change)="onUpdateTermAndServiceAgreement($event)"
               name="acceptTermService">
        <label class="custom-control-label" [ngClass]="{'custom-control-label-error': isTermAndConditionError}">
          <span class="link-text" [innerHTML]="'INFLUENCER.confirmation.term_service' | translate"></span>
        </label>
      </div>
      <button class="button blue"
              type="submit">{{'common.btn.confirm' | translate}}</button>
    </div>
    <div class="term-service d-flex flex-column d-sm-none">
      <div class="custom-control custom-checkbox d-flex flex-auto align-items-center">
        <input class="custom-control-input"
               type="checkbox"
               (change)="onUpdateTermAndServiceAgreement($event)"
               name="acceptTermService">
        <label class="custom-control-label" [ngClass]="{'custom-control-label-error': isTermAndConditionError}">
          <span class="link-text" [innerHTML]="'INFLUENCER.confirmation.term_service' | translate"></span>
        </label>
      </div>
      <div class="d-flex flex-auto justify-content-end">
        <button class="button blue"
                type="submit">{{'common.btn.confirm' | translate}}</button>
      </div>
    </div>
  </form>
</div>



// WEBPACK FOOTER //
// ./src/app/influencer-platform/influencer-details/influencer-confirmation/influencer-confirmation.component.html